export const UrlConstants = {
  GET_DOMAIN_CONFIG: '/domain-configuration',
};

export default UrlConstants;
